import type { ILocationItemResponseBody } from '../../../types/response/ILocationItemResponseBody';
import { BaseFootprint } from './BaseFootprint';
import { BaseLocation } from './BaseLocation';
import type { BaseLocationEvent } from './BaseLocationEvent';
import { LocationEvent } from './LocationEvent';
import { LocationExternalSource } from './LocationExternalSource';
import { Tweet } from './Tweet';

export class Location extends BaseLocation {
  private readonly _events: BaseLocationEvent[];
  private readonly _tweets: Tweet[];
  private readonly _externalSources: LocationExternalSource[];
  constructor(
    locationId: string,
    kakaoUid: string | null,
    naverUid: string | null,
    googleUid: string | null,
    name: string,
    description: string | null,
    category: string,
    siteType: string,
    streetAddress: string,
    lotAddress: string,
    latitude: number,
    longitude: number,
    likesCount: number,
    postsCount: number,
    distanceInMeters: number | null,
    isLiked: boolean,
    isLandmark: boolean,
    isShutdown: boolean,
    events: BaseLocationEvent[],
    tweets: Tweet[],
    externalSources: LocationExternalSource[],
    footprints: BaseFootprint[]
  ) {
    super(
      locationId,
      kakaoUid,
      naverUid,
      googleUid,
      name,
      description,
      category,
      siteType,
      streetAddress,
      lotAddress,
      latitude,
      longitude,
      likesCount,
      postsCount,
      distanceInMeters,
      isLiked,
      isLandmark,
      isShutdown,
      footprints
    );
    this._events = events;
    this._tweets = tweets;
    this._externalSources = externalSources;
  }

  get events(): BaseLocationEvent[] {
    return [...this._events];
  }

  get tweets(): Tweet[] {
    return [...this._tweets];
  }

  get externalSources(): LocationExternalSource[] {
    return [...this._externalSources];
  }

  static fromResponse(response: ILocationItemResponseBody): Location {
    return new Location(
      response.locationId,
      response.kakaoUid,
      response.naverUid,
      response.googleUid,
      response.name,
      response.description,
      response.category,
      response.siteType,
      response.streetAddress,
      response.lotAddress,
      response.latitude,
      response.longitude,
      response.likesCount,
      response.postsCount,
      response.distanceInMeters,
      response.isLiked,
      response.isLandmark,
      response.isShutdown,
      response.events.map((event) => LocationEvent.fromResponse(event)),
      response.tweets.map((tweet) => Tweet.fromResponse(tweet)),
      response.externalSources.map((externalSource) =>
        LocationExternalSource.fromResponse(externalSource)
      ),
      response.footprints.map((footprint) => BaseFootprint.fromResponse(footprint))
    );
  }
}
